import { Link } from 'react-router-dom';

const Folders = ({data}) => {
    console.log(data)
    return (
        <div className="project">
            {
                data.map((item, i) => <Link to={`${item.link}`} className={`project__item fadeIn delay${i+1}00`} key={i}>{item.name}</Link>)
            }                
        </div>
    )
}

export default Folders